import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from "react-redux";
import {
  BrowserRouter as Router,
  Route,
  Switch
} from 'react-router-dom';
import './index.css';

import App from './App';
import TransactionDetails from './containers/transactionDetails/transactionDetailsContainer';
import Layout from './containers/layout/layoutContainer';
import TransactionSummary from './containers/transactionSummary/transactionSummaryContainer';
import TnC from './containers/tnc/tncContainer';
import Error from './containers/error/error';
import Temp_unavailable from './containers/error/temp_unavailable/temp_unavailable'
import PageNotFound from './containers/error/404';
import LoginError from './containers/error/loginError';
import configureStore from './core/store/configurationStore';
import withTokens from './components/HOC/authenticationChecker';
import { APP_URLS } from './constants/constants';
import VerifyOtp from './containers/otp/verifyOtpContainer';
import Success from './containers/success/successContainer';
import UploadDocument from './containers/uploadDocument/uploadDocumentContainer';
import Confirm from './containers/confirm/confirmContainer';
import NewToBank from './containers/newtobank/NTB';
import MpinSuccess from './containers/mpinStatus/mpinSuccess';	
import MpinFail from './containers/mpinStatus/mpinFail';
import Intermediary from './containers/perfiosIntermediary/Intermediary';

const store = configureStore();
const rootElement = document.getElementById("root");

const routes = (
  <Provider store={store}>
    <Router>
      <Layout>
        <Switch>
          <Route component={App} exact path={APP_URLS.LOGIN} />
          <Route component={withTokens(TransactionDetails)} path={APP_URLS.TRANSACTION_DETAILS} />
          <Route component={withTokens(TransactionSummary)} path={APP_URLS.TRANSACTION_SUMMARY} />
          <Route component={withTokens(TnC)} path={APP_URLS.TNC} />
          <Route component={withTokens(VerifyOtp)} path={APP_URLS.OTP} />
          <Route component={withTokens(Success)} path={APP_URLS.SUCCESS} />
          <Route component={withTokens(Error)} exact path={APP_URLS.ERROR} />
          <Route component={withTokens(UploadDocument)} exact path={APP_URLS.DOCUMENT_UPLOAD} />
          <Route component={withTokens(Confirm)} exact path={APP_URLS.CONFIRM} />
          <Route component={NewToBank} exact path={APP_URLS.NTB}/>
          <Route component={Error} exact path={APP_URLS.COMMON_ERROR} />
          <Route component={Temp_unavailable} exact path={APP_URLS.TEMP_DOWN} />
          <Route component={LoginError} exact path={APP_URLS.ERROR_LOGIN} />
          <Route component={MpinSuccess} exact path={APP_URLS.MPIN_SUCCESS} />	
          <Route component={MpinFail} exact path={APP_URLS.MPIN_ERROR} />
          <Route component={withTokens(Intermediary)} exact path={APP_URLS.VERIFY_SUCCESS} />
          <Route component={PageNotFound} />
        </Switch>
      </Layout>
    </Router>
  </Provider>
)

require('dotenv').config()

ReactDOM.render(routes, rootElement);

